import { promoteFirstCharacterStyle } from '@/commons/fabricjs/FabricTextHelper';
import { Textbox } from 'fabric';

/**
 * Textbox used for every editable text of the canvas.
 * It keeps the `textbox` type and the fabric serialization / cloning behaviour of the base class.
 */
class WTextbox extends Textbox {
    /**
     * Fabric resets `styles` to {} as soon as the hidden textarea is empty, dropping every character
     * level style (font, color, size...). Keep the look of the first character at object level so the
     * next typed text does not fall back to the default font.
     */
    onInput(this: this & { hiddenTextarea: HTMLTextAreaElement }, e: Event) {
        if (this.isEditing && this.hiddenTextarea.value === '' && this._text.length > 0) {
            promoteFirstCharacterStyle(this);
        }
        super.onInput(e);
    }
}

export { WTextbox };
